import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"search\"><title>_search</title><g id=\"search_album\"><path d=\"M35.707,34.293l-9.5484-9.5485a12.0146,12.0146,0,1,0-1.4141,1.4141L34.293,35.707a1,1,0,0,0,1.414-1.414ZM7,17A10,10,0,1,1,17,27,10.0113,10.0113,0,0,1,7,17Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/search.svg
// module id = dZHa
// module chunks = 4